"use client";
import { cn } from "@/lib/utils";
import ProgramEnrollButton, {
  ProgramEnrollButtonProps,
} from "../ProgramEnrollButton";
type ProgramMidPageCTA = ProgramEnrollButtonProps & {
  className?: string;
};
export default function MidPageCTA(props: ProgramMidPageCTA) {
  return (
    <div className={cn("flex flex-col text-center gap-4", props.className)}>
      <h2 className="md:text-3xl font-bold my-0">
        Ready to advance your career?
      </h2>
      <div className="self-center w-full sm:w-auto px-6">
        <ProgramEnrollButton {...props} />
      </div>
    </div>
  );
}
